import React from 'react';

const context = {
  meta: {},
  share: {},
  configs: {},
  publicModules: {},
  branding: {},
  userPortalMenus: {},
};
export default React.createContext(context);
